module.exports = __webpack_public_path__ + "img/logo-dark.6acfc99.svg";